import React, { useId, useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { AssetImage } from './AssetImage';
import type { Volume } from '../data/collection';
interface VolumeCardProps {
  volume: Volume;
}

/**
 * Cover + summary first. On phones the model list is folded behind a toggle;
 * from md up it is always visible.
 */
export function VolumeCard({
  volume
}: VolumeCardProps) {
  const [open, setOpen] = useState(false);
  const listId = useId();
  const count = volume.models.length;
  return <article className="flex w-full min-w-0 flex-col rounded-[18px] bg-paper p-4 ring-1 ring-ivory-line sm:p-5" data-id="element-298" data-mp="1pu1q3plym21x">
      <div className="overflow-hidden rounded-[6px] shadow-[0_16px_30px_-22px_rgba(52,52,49,0.55)] ring-1 ring-graphite/10" data-id="element-299" data-mp="1l2jpx3rrg5i0">
        <div className="bg-paper" style={{
        aspectRatio: `${volume.cover.width} / ${volume.cover.height}`
      }} data-id="element-300" data-mp="1h1rfi775juk5">
          <AssetImage image={volume.cover} fit="contain" data-id="element-301" data-mp="2dm0enbaf5tx0" />
        </div>
      </div>

      <div className="mt-5 flex min-w-0 flex-wrap items-baseline justify-between gap-x-3 gap-y-1.5" data-id="element-302" data-mp="28rw5cldol9sr">
        <h3 className="font-serif text-[1.5rem] font-semibold text-graphite" data-id="element-303" data-mp="37csgu25og9im">Volumen {volume.number}</h3>
        <span className="whitespace-nowrap rounded-full bg-blush px-3 py-1 text-[0.88rem] font-bold text-coral-ink" data-id="element-304" data-mp="3cd6fwupaw94i">
          {count} modelos
        </span>
      </div>
      <p className="mt-1.5 text-[1rem] leading-relaxed text-graphite-soft" data-id="element-305" data-mp="32jzefkxold9p">{volume.summary}</p>
      <p className="mt-2 text-[0.88rem] font-semibold text-sage-ink" data-id="element-306" data-mp="2okhi8ki22xqb">Manual + moldes A4 en PDF separados</p>

      <button type="button" onClick={() => setOpen(value => !value)} aria-expanded={open} aria-controls={listId} className="mt-4 flex min-h-[48px] w-full items-center justify-between rounded-full bg-ivory px-4 text-[0.95rem] font-bold text-graphite ring-1 ring-inset ring-ivory-line transition-colors duration-150 ease-out hover:text-coral-ink focus:outline-none focus-visible:ring-4 focus-visible:ring-coral/40 md:hidden" data-id="element-307" data-mp="2tldmiz6bklw9">
        {open ? 'Ocultar modelos' : `Ver los ${count} modelos`}
        <ChevronDownIcon className={`h-5 w-5 transition-transform duration-200 ease-out ${open ? 'rotate-180' : ''}`} aria-hidden data-id="element-308" data-mp="gbjhtg0r95pe" />
      </button>

      <ul id={listId} className={`mt-4 space-y-2 border-t border-dashed border-coral/35 pt-4 md:block ${open ? 'block' : 'hidden'}`} data-id="element-309" data-mp="6fzyru7ai1i2">
        {volume.models.map(model => <li key={model} className="flex gap-2.5 text-[1rem] leading-snug text-graphite" data-id="element-310" data-mp="z3m00vt1ou1r">
            <span aria-hidden className="mt-[0.45em] h-1.5 w-1.5 shrink-0 rounded-full bg-sage" data-id="element-311" data-mp="u5u8w4085bym" />
            {model}
          </li>)}
      </ul>
    </article>;
}